import Vue from 'vue'

import IntegrationsAPI from '@/api/integrations'

const state = {
    connected: []
};

const mutations = {
    setConnectedIntegrations(state, list) {
        state.connected = list;
    },
    addConnectedIntegration(state, item) {
        state.connected.push(item);
    },
    removeConnectedIntegration(state, id) {
        state.connected = state.connected.filter(it => it._id != id);
    }
};

const actions = {
    fetchConnected(context, {
        cafe_id
    }) {
        return new Promise((resolve, reject) => {
            IntegrationsAPI.getConnected(
                cafe_id
            ).then(data => {
                context.commit('setConnectedIntegrations', data.integrations);

                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    connectIntegration(context, integration) {
        return new Promise((resolve, reject) => {
            IntegrationsAPI.connectIntegration(
                context.rootState.cafe._id,
                integration._id
            ).then(data => {
                context.commit('addConnectedIntegration', integration);

                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    disconnectIntegration(context, integration) {
        return new Promise((resolve, reject) => {
            IntegrationsAPI.disconnectIntegration(
                context.rootState.cafe._id,
                integration._id
            ).then(data => {
                context.commit('removeConnectedIntegration', integration._id);

                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    }
};

const getters = {
    isConnected(state) {
        return id => !!state.connected.find(it => it._id == id);
    },
    isConnectedByTag(state) {
        return tag => !!state.connected.find(it => it.tag == tag);
    },
    navbarRoutes(state) {
        return state.connected.filter(it => {
            return it.platform_options && it.platform_options.add_to_navbar
        }).map(it => {
            return {
                path: it.platform_options.navbar_route,
                title: it.platform_options.navbar_title,
                imageIcon: it.platform_options.navbar_icon,
                category: it.category
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
